import { GraphQLClient } from 'graphql-request';
import {getSdk} from "../generated/graphql";

export const apiClient = new GraphQLClient('https://homebase.rustlounge.gg/query')
export const apiSdk = getSdk(apiClient);